export default {
	props: {
		alert: { type: Object },
		hideIcon: { type: Boolean },
		takeActionButtonTitle: { type: String },
	},
};
